// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"tagsForm_footerContainer__3jUKD","container":"tagsForm_container__3gmFr"};